import React, {Component} from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Carousel } from 'react-responsive-carousel';
import YouTube from 'react-youtube';
import RepostButtons  from '../../common/view/RepostButtons';
import productSellTypes  from '../../../common/productSellTypes';
import dummyImage from '../../../../images/small/img-1.jpg';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

class ProductViewPage extends React.Component {
    constructor(props) {
        super(props);
    }

    getPublishedInfo() {
        let product = this.props.product;
        let result = [];

        product.categories.forEach((category, key) => {
            result.push(<b key={key}>{category.name} | </b>)
        });

        return result;
    }

    getCarousel() {
        let product = this.props.product;

        if(!product.images.length) {
            return null;
        }

        return <div className="row mb-4">
            <div className="col-12">
                <Carousel
                    showArrow={false}
                    showStatus={false}
                    showIndicators={false}
                    showThumbs={false}
                    dynamicHeight={true}
                >
                    {
                        product.images.map(function (image, key) {
                            return <div key={key}>
                                <img src={image.path} />
                            </div>
                        })
                    }
                </Carousel>
            </div>
        </div>;
    }

    renderIfNotNull(checkedValue, reactElem) {
        if(!checkedValue) {
            return null;
        }

        return reactElem;
    }

    render() {
        let {
            product,
        } = this.props;

        return <div>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-block">
                            <div className="row">
                                <div className="col-12">
                                    <header><h1>{product.title}</h1></header>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-8">
                                    {this.getPublishedInfo()}
                                </div>
                                <div className="col-4 pull-right">
                                    <div className="pull-right">
                                        <RepostButtons/>
                                    </div>
                                </div>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-md-7 mb-4 pr-3">
                                    {this.getCarousel()}
                                    <div className="row">
                                        <div className="col-12">
                                            {ReactHtmlParser(product.description)}
                                        </div>
                                    </div>
                                    <hr/>
                                    {
                                        product.videoLink
                                            ?
                                            <div className="row">
                                                <div className="col-sm-10">
                                                    <div className="embed-responsive embed-responsive-16by9">
                                                        <YouTube videoId={product.videoLink}/>
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                    }
                                </div>
                                <div className="col-md-5">
                                    <div className="table-rep-plugin">
                                        <div className="table-wrapper">
                                            <div className="table-responsive b-0">
                                                <table className="table table-striped">
                                                    <tbody>
                                                    <tr>
                                                        <th>Producent / Forhandler</th>
                                                        <td>{productSellTypes[product.publicationType]}</td>
                                                    </tr>
                                                    {
                                                        (product.priceAmount && product.currency && product.priceType) ?
                                                            <tr>
                                                                <th>Pris</th>
                                                                <td>{`${product.priceAmount} ${product.currency.name} ${product.priceType.name}`}</td>
                                                            </tr>
                                                            : null
                                                    }
                                                    {this.renderIfNotNull(product.manufacturer, <tr>
                                                        <th>Producent</th>
                                                        <td>{product.manufacturer}</td>
                                                    </tr>)}
                                                    {this.renderIfNotNull(product.model, <tr>
                                                        <th>Model</th>
                                                        <td>{product.model}</td>
                                                    </tr>)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    {product.contactPerson ?
                                        <div className="row">
                                            <div className="col-md-7 col-lg-7 col-xl-7">
                                                <div className="card mt-4">
                                                    <div className="card-block">
                                                        <h4 className="card-title font-20 mt-0">Kontaktperson</h4>
                                                    </div>
                                                    <img
                                                        className="img-fluid"
                                                        src={
                                                            (product.contactPerson.image instanceof Object && product.contactPerson.image.path)
                                                                ? product.contactPerson.image.path
                                                                : dummyImage
                                                        }
                                                        alt="Kontaktperson"
                                                    />
                                                    <div className="card-block">
                                                        <h4 className="card-title font-20 mt-0">{product.contactPerson.name}</h4>

                                                        <b className="text-muted">Tlf.: </b> {product.contactPerson.phone}
                                                        <p>
                                                            <a href={`mailto:${product.contactPerson.email}`}>{product.contactPerson.email}</a>
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        : null
                                    }
                                    {product.link ?
                                        <div className="row mt-2">
                                            <div className="col-12">
                                                <a className="btn btn-primary" href={product.link} target="_blank">
                                                    <i className={'fa fa-external-link'}></i> &nbsp;{'Referencenr'}
                                                </a>
                                            </div>
                                        </div>
                                        : null
                                    }
                                </div>
                            </div>
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
};

export default ProductViewPage;


// WEBPACK FOOTER //
// ./web/src/components/products/view/ProductViewPage.jsx